import { ChangeEvent } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { useToast } from "@/components/ui/use-toast"
import { useSettingsStore } from "@/lib/store"

export default function Settings() {
  const { apiKey, voiceId, setSettings } = useSettingsStore()
  const { toast } = useToast()

  const handleSave = () => {
    if (!apiKey || !voiceId) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please fill in all required fields.",
      })
      return
    }

    setSettings({ apiKey, voiceId })

    toast({
      title: "Success",
      description: "Settings saved successfully.",
    })
  }

  const handleApiKeyChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSettings({ apiKey: e.target.value })
  }

  const handleVoiceIdChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSettings({ voiceId: e.target.value })
  }

  return (
    <div className="container mx-auto py-8">
      <Card>
        <CardHeader>
          <CardTitle>Settings</CardTitle>
          <CardDescription>
            Configure your API keys and preferences
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="apiKey">OpenAI API Key</Label>
            <Input
              id="apiKey"
              type="password"
              value={apiKey}
              onChange={handleApiKeyChange}
              placeholder="Enter your OpenAI API key"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="voiceId">ElevenLabs Voice ID</Label>
            <Input
              id="voiceId"
              value={voiceId}
              onChange={handleVoiceIdChange}
              placeholder="Enter your ElevenLabs Voice ID"
            />
          </div>
          <Button onClick={handleSave}>Save Settings</Button>
        </CardContent>
      </Card>
    </div>
  )
} 